import React, { useContext } from "react";
import { selectedDrawerStatus } from "@src/ducks/slices/dashboard.slice";
import { TouchableOpacity, View, Image, Pressable, useWindowDimensions } from "react-native";
import { useDashboardService } from "@src/ducks/hooks";
import { useAppSelector } from "@src/ducks/ducksHook";
import Icon from "@expo/vector-icons/Feather";
import { DrawerContext } from "../drawer-provider";
import useStyles from "./styles.css";
import images from "@assets/images";
import colors from "@assets/colors";
import SVGIcon from "@assets/svg";
import { largeSize } from "@src/utils/screensize-helper";
import { useNavigation } from '@react-navigation/native';
import { useRDrawer } from "@src/components/drawer/provider";
// import { DrawerActions } from '@react-navigation/native';
// import { useDrawerStatus } from '@react-navigation/drawer';


const MobileHeader = () => {
  const navigation = useNavigation();
  // const drawerStatus = useDrawerStatus();
  // const isDrawerOpen = drawerStatus === 'open';
  const { isVisible: isRDrawerVisible, toggleDrawer } = useRDrawer()
  const styles = useStyles();
  const isLargeSize = largeSize();
  const { onDrawerEnable } = useDashboardService();
  const drawerEnable = useAppSelector(selectedDrawerStatus);
  const { onActiveTab } = useContext(DrawerContext);

  const size = React.useMemo(() => {
    if(isLargeSize){
      return { logo: {
        width: 42,
        height: 60,
      }, signsecure: {
        width: 185,
        height: 61.5,
      }
      };
    }

    return { logo: {
      width: 42,
      height: 60,
    }, signsecure: {
      width:150,
      height: 52,
    }
    };
  },[isLargeSize]);

  React.useEffect(() => {
    if (!isRDrawerVisible) {
      onDrawerEnable(false)
    }
  }, [isRDrawerVisible]);

  return (
    <View style={styles.drawer_mobile_container}>
      <Pressable android_ripple={null} android_disableSound={true} onPress={() => onActiveTab("Dashboard")}>
        <SVGIcon name="SignsecureMobileHeader" {...size.signsecure} /> 
      </Pressable>
      <TouchableOpacity style={{ top: 1, }} onPress={() => {
          onDrawerEnable(!drawerEnable)
          toggleDrawer();
        }}>
        <Icon name={drawerEnable ? "x" : "menu"} size={30} color={colors.black} />
      </TouchableOpacity>
    </View>  
  );
};

export default MobileHeader;
